// extracted by css-extract-rspack-plugin
export default {"defaultSize":"dq4vZnhP","defaultFillColor":"dfv6Qpcs"};